import React, { Component } from 'react';
import ImportSupplierComp from '../../../components/suppliers/import';

export default class ImportSupplier extends Component {
	render() {
		return <ImportSupplierComp />;
	}
}
